import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery, pyrotchBaseUrl } from "../axios/AxiosInstance";

export type AiTaskType =
  | "SUMMARY"
  | "CATCH_ME_UP"
  | "EXTRACT_ACTION_ITEMS"
  | "EXTRACT_DECISIONS"
  | "EXTRACT_RISKS"
  | "EXTRACT_DEADLINES"
  | "EXTRACT_FILES"
  | "THREAD_SUMMARY"
  | "UNREAD_SUMMARY"
  | "DAILY_SUMMARY"
  | "WEEKLY_SUMMARY"
  | "PROJECT_CHAT_SUMMARY"
  | "PROJECT_STATUS_REPORT"
  | "WEEKLY_PROJECT_REPORT"
  | "MEETING_SUMMARY"
  | "SEARCH"
  | "QUESTION_ANSWER"
  | "FIND_UNANSWERED_QUESTIONS"
  | "FIND_COMMITMENTS"
  | "FIND_OVERDUE_COMMITMENTS"
  | "IDENTIFY_CONFLICTS"
  | "IDENTIFY_IMPORTANT";

export interface AiScope {
  type: "CONVERSATION" | "PROJECT" | "ALL";
  conversationId?: number;
  projectId?: number;
  sinceHours?: number;
  unreadOnly?: boolean;
}

export interface AiStructuredItem {
  messageId: number;
  conversationId: number;
  summary: string;
}

export interface AiQueryResponse {
  resultText?: string;
  structuredItems?: AiStructuredItem[];
}

export const AiAssistantApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "aiAssistantApi",
  endpoints: (build) => ({
    askAi: build.mutation<AiQueryResponse, { scope: AiScope; task: AiTaskType; question?: string }>({
      query: (data) => ({
        url: "chat/ai/query",
        method: "POST",
        data,
      }),
    }),
  }),
});

export const { useAskAiMutation } = AiAssistantApi;
